import { Component, OnInit } from '@angular/core';
import {
  MatDialogRef,
} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { S3ServiceService } from './../../../../services/s3Service/s3-service.service';
import { DocumentEnum } from 'src/app/services/documentsOperation/DocumentEnum';
import { observableToPromise } from 'src/app/services/ObservableToPromise';
import * as JSZip from "jszip";
import { saveAs } from "file-saver";



@Component({
  selector: 'app-export-documents-zip',
  templateUrl: './export-documents-zip.component.html',
  styleUrls: ['./export-documents-zip.component.scss'],
})
export class ExportDocumentsZipComponent implements OnInit {
  position = { value: 'above' };
  docSearch=[];
  fileDownloadUrl;
  docArray = [
    DocumentEnum.AADHAAR,
    DocumentEnum.PAN,
    DocumentEnum.VOTER_ID,
    DocumentEnum.ADDRESS_PROOF
  ];
  constructor(
    public dialogRef: MatDialogRef<ExportDocumentsZipComponent>,
    private toast: ToastrService,
    private s3Service: S3ServiceService,
  ) {}

  ngOnInit(): void {}
  matDialogClose() {
    this.dialogRef.close();
  }

async onDownload() {
    this.toast.success("Downloading...");
    try{
      let prefix="Documents-zip/";
       const responseFiles: any = await observableToPromise(
                this.s3Service.getFolderList(prefix)
              ); 

    let zipFiles = responseFiles.body?.files || [];
    const zip = new JSZip();
    const folderName = "Documents"; // folder inside the final ZIP
    const folder = zip.folder(folderName);

    for (let i in zipFiles) {
      if (this.docHit(zipFiles[i])) {
        // Get presigned URL
        const responsePreSignUrl: any = await observableToPromise(
          this.s3Service.getGetPresignedUrl(zipFiles[i])
        );

        const url = responsePreSignUrl.body.url;
        const response = await fetch(url);
        const blob = await response.blob();

        // Get original file name from S3 path
        const originalFileName = zipFiles[i].split('/').pop() || `file_${i}.zip`;

        // Add the entire ZIP as-is to the folder
        folder?.file(originalFileName, blob);
      }
    }

    // Create the final ZIP with all S3 zips inside
    const content = await zip.generateAsync({ type: "blob" });
    saveAs(content, "Documents.zip");

    this.toast.success(`Downloaded Successfully`);
    this.dialogRef.close();
  } catch (e) {
    console.error("Error while downloading : ", e);
  }
}

   getFormattedType(value: string): string {
    const words = value.toLowerCase().split('_');
    return words
      .map((word) => {
        if (word === 'pan') return 'PAN';
        if (word === 'id') return 'ID';
        if (word === 'license') return 'License';
        if (word === 'card') return 'Card';
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  docHit(zipFile)
  {
    for(let i in this.docSearch)
    {
      if(zipFile.includes(this.docSearch[i]))
      {
        return true;
      }
    }
  }
  
}
